import translations from '@/utils/common/translations'

export default function(key) {
  const val = translations[key]
  return val ? val : key
}
